import { Field } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  requestTo
} from "../../components/action-buttons/ActionButtonGenerator";
import { Accordion, Button, Card } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import CurrencyInput from "../../components/form-fields/CurrencyInput";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import { useTranslation } from 'react-i18next';                   /* Added Line */

export default function DocumentTypes() {
  const [showModal, setShowModal] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [refreshConfig, setRefreshConfig] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [departmanId, setDepartmanId] = useState(null);
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("filter");
  const [filters, setFilters] = useState([]);
  const [t, i18n] = useTranslation();         /* Added Line */

  const validationSchema = yup.object({
  });

  const arrangeBeforePersist = (values) => {
    let payload = {
      talepTurId: values.talepTurId,
      departmentId: values.departmentId,
      turKod: values.turKod,
      dosyaTuru: values.dosyaTuru,
      dosyaTuruEn: values.dosyaTuruEn,
      dosyaTuruTr: values.dosyaTuruTr,
      ucret: values.ucret,
      id: values.id,
      parentId: values.parentId,

    };
    return payload;
  };

  const adaptDataForUpdate = (data) => {
    let adaptedData = {
      talepTurId: data.talepTurId,
      departmentId: data.departmentId,
      turKod: data.turKod,
      dosyaTuru: data.dosyaTuru,
      dosyaTuruEn: data.dosyaTuruEn,
      dosyaTuruTr: data.dosyaTuruTr,
      ucret: data.ucret,
      id: data.id,
      parentId: data.parentId,
    };
    setInitialValues(adaptedData);
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setDepartmanId(selectedRow.departmentId);
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(false);
    setInitialValues({});
  };

  const onDepartmentChanged = (value) => {
    setDepartmanId(value);
    setRefreshConfig(!refreshConfig);
  };
  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
        <Button className="btn-xs"
        onClick={() => {
          onUpdateButtonClicked(row);
        }}
      >
        <i className="fa fa-search color-white"></i>
      </Button>
    );
  };
  return (
    <Main>
      <div className={"row"}>
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="filter"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="dosya-tur/config"
                    // configParameterValue={16}
                    configParameterName="id"
                    configParameterValue={departmanId}
                    configReqType={"POST"}
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                    refreshConfig={refreshConfig}
                  >
                    <Field
                      name="departmentId"
                      label={t("documentTypes.departman")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      oper="EQ"
                      options={configData && configData.department}
                      onChangeFunc={(opt) => onDepartmentChanged(opt)}
                    />
                    <Field
                      name="talepTurId"
                      label={t("documentTypes.talepTuru")}
                      colNumber="3"
                      oper="EQ"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.talepTur}
                    />
                    <Field
                      name="dosyaTuruTr"
                      label={`${t("documentTypes.dosyaTürüTr")}`}
                      colNumber="3"
                      component={TextInput}
                      oper="CONTAINS_CASE_AND_ACCENT_INSENSITIVE"
                    />
                    <Field
                      name="dosyaTuruEn"
                      label={`${t("documentTypes.dosyaTürüEn")}`}
                      colNumber="3"
                      component={TextInput}
                      onlyEnglish={true}
                      oper="CONTAINS_CASE_AND_ACCENT_INSENSITIVE"
                    />
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
    <div className="row">
      <div className="col-xl-12 col-xxl-12">
        <CrudMain
          onAddButtonClicked={onAddButtonClicked}
          showModal={showModal}
          setShowModal={setShowModal}
          title={t("sidebar.dosyaTürleri")}
        >
          <FormikForm
            isUpdating={isUpdating}
            entityId={selectedRow && selectedRow.id}
            entityFetchId="id"
            configParameterName="id"
              configParameterValue={departmanId}
              configReqType={"POST"}
            endPointUrl="dosya-tur/create"
            fetchPointUrl="dosya-tur/find"
            editPointUrl="dosya-tur/update"
            configPointUrl="dosya-tur/config"
            arrangeBeforePersist={arrangeBeforePersist}
            adaptDataForUpdate={adaptDataForUpdate}
            setConfigData={(data) => setConfigData(data)}
            initialValues={initialValues}
            validationSchema={validationSchema}
            closeModal={() => setShowModal(false)}
            refreshList={() => setRefreshList(!refreshList)}
          >
            <Field
              name="departmentId"
              label={t("documentTypes.departman")}
              colNumber="12"
              component={Select}
              options={configData && configData.department}
              onChangeFunc={(opt) => onDepartmentChanged(opt)}
            />
         {/*    <Field
              name="parentId"
              label={t("documentTypes.üstTür")}
              colNumber="12"
              component={Select}
              options={configData && configData.dosyaTur}
            /> */}
            <Field
              name="talepTurId"
              label={t("documentTypes.talepTürleri")}
              colNumber="12"
              component={Select}
              options={configData && configData.talepTur}
            />
            <Field
              name="turKod"
              label={t("documentTypes.türKodu")}
              colNumber="12"
              component={TextInput}
              readOnly
            />

            <Field
              name="dosyaTuruTr"
              label={t("documentTypes.dosyaTürüTr")}
              colNumber="12"
              component={TextInput}
            /><Field
              name="dosyaTuruEn"
              label={t("documentTypes.dosyaTürüEn")}
              colNumber="12"
              component={TextInput}
              onlyEnglish={true}
            />
            <Field
              name="ucret"
              label={t("documentTypes.ücret")}
              colNumber="12"
              component={CurrencyInput}
              required
            />
          </FormikForm>
        </CrudMain>
      </div>
    </div>

    <div className="row">
      <div className="col-md-12">
        <ListComponent
          entityName="dosya-türleri"
          endpoint="dosya-tur/list"
          keyField="id"
          refreshList={refreshList}
          hideSelection = {true}
          columns={[
            {
              dataField: "id",
              text: "ID",
              sort: true,
              headerClasses: "id-header"
            },
            {
              dataField: "departmentName",
              text: `${t("demandList.departmanAdi")}`,
              sort: true,
            },
            {
              dataField: "talepTurName",
              text: `${t("demandList.talepTuru")}`,
              sort: true,
            },
            {
              dataField: "turKod",
              text: `${t("demandList.turKodu")}`,
              sort: true,
            },
            {
              dataField: "dosyaTuruTr",
              text: `${t("demandList.dosyaTuruTr")}`,
              sort: true,
            },
            {
              dataField: "dosyaTuruEn",
              text: `${t("demandList.dosyaTuruEn")}`,
              sort: true,
            },
            {
              dataField: "",
              text: "İşlemler",
              formatter: linkFollow,
              sort: false,
            },
          ]}
          customBody={{
            filters: filters,
          }}
          actionButtonsObject={{
            actions: [
              pushToParams(ABT.EDIT, onUpdateButtonClicked),
              requestTo(ABT.DELETE, "dosya-tur/delete"),
            ],
            generator: DefaultActionButtonGenerator,
          }}
        />
      </div>
    </div>
  </Main>
  );
}
